<!-- 提交订单页面 -->
<template>
  <div class="submitBox">
    <h1 style="margin-bottom:20px;">请填写订单信息~</h1>
    <div class="showAddress">
      <h4>收货地址</h4>
      <el-dropdown trigger="click" @visible-change="visibleChange($event)">
        <div class="info-box" style="padding-right:180px;">
          <span style="width:742px;" class="addressInfo">
            <span>{{ form.address.fname ? form.address.fname : "" }}</span>
            <span style="padding-left: 10px">{{
              form.address.fPhoneNo ? form.address.fPhoneNo : ""
            }}</span>
            <span>
              {{ form.address.fLevelName ? form.address.fLevelName : "" }}
            </span>
            <span>
              {{ form.address.fAddress ? form.address.fAddress : '' }}
            </span>
            <span v-if="form.address.index === 0" class="default">默认</span>
          </span>
          <span class="addAddress" @click.stop="addButton('新增收货地址')">新增地址</span>
          <svg-icon icon-class="select" />
        </div>
        <el-dropdown-menu slot="dropdown" class="addressSelect">
          <el-dropdown-item
            v-for="(item, index) in orderData.message"
            :key="index"
            class="addressList"
            @click.native="command(item, index)"
          >
            <div>
              <div class="name">
                <span>{{ item.fname }}</span>
                <span style="padding-left: 10px">{{ item.fPhoneNo }}</span>
              </div>
              <div class="bottom">
                <span>
                  {{ item.fLevelName }}
                </span>
                <span>
                  {{ item.fAddress }}
                </span>
              </div>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <p class="moreAddress">更多地址({{ orderData.message.length }})</p>
    </div>
    <div class="showAddress">
      <h4>支付方式</h4>
      <div style="display:flex;">
        <div class="info-box" style="padding-right:20px;">
          <span style="color:#EC212D;">
            可用额度
          </span>
          <svg-icon icon-class="select" />
        </div>
        <div class="useQuato">当前可用额度 <span style="margin-left:12px;">￥<span
          style="font-size:28px;"
        >
          {{ moneyFilter(paymode[0].availableAmount)[0] }}</span>.{{ moneyFilter(paymode[0].availableAmount)[1] }}
        </span>
          </span></div>
      </div>
    </div>
    <div v-if="BuyDepartList.length" class="showAddress">
      <h4>下单部门</h4>
      <el-dropdown trigger="click" @visible-change="visibleChange($event)">
        <div class="info-box" style="padding-right:110px;">
          <span style="width:220px;" class="addressInfo">
            {{ departInfo.FDepartName }}
          </span>
          <span class="addAddress">更多部门</span>
          <svg-icon icon-class="select" />
        </div>
        <el-dropdown-menu slot="dropdown" class="departSelect">
          <el-dropdown-item
            v-for="(item, index) in BuyDepartList"
            :key="index"
            class="departList"
            @click.native="departChange(item, index)"
          >
            <div>
              <div class="name">
                <span>{{ item.FDepartName }}</span>
              </div>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <div class="departInfo">
        <div class="topArrow" />
        <div class="content">
          <p>
            <span class="title">发票抬头</span>：{{ departInfo.FInvoiceUnitName }}
          </p>
          <p>
            <span class="title">开户银行</span>：{{ departInfo.FBank }}
          </p>
          <p>
            <span class="title">税号</span>：{{ departInfo.FTaxNo }}
          </p>
          <p>
            <span class="title">银行账户</span>：{{ departInfo.FAccountNo }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="ApprovalList.length" class="showAddress">
      <h4>审批流程</h4>
      <el-dropdown trigger="click" @visible-change="visibleChange($event)">
        <div class="info-box" style="padding-right:110px;">
          <span style="width:220px;" class="addressInfo">
            {{ approvalInfo.FApprovalName }}
          </span>
          <span class="addAddress">更多审批</span>
          <svg-icon icon-class="select" />
        </div>
        <el-dropdown-menu slot="dropdown" class="departSelect">
          <el-dropdown-item
            v-for="(item, index) in ApprovalList"
            :key="index"
            class="departList"
            @click.native="approvalChange(item, index)"
          >
            <div>
              <div class="name">
                <span>{{ item.FApprovalName }}</span>
              </div>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <div class="approval-box" style="display:flex;">
        <div v-for="(t,i) in approvalInfo.ApprovalDetailList" :key="i" class="process-list">
          <svg-icon v-if="i != 0" :icon-class="processArr[i].svgClass" />
          <div :style="processArr[i].style" class="process-box">
            <div class="process-title">
              {{ processArr[i].text }}
            </div>
            <div class="process-content">
              <div class="process-text">
                {{ t.FUserName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="showAddress">
      <h4>订单备注</h4>
      <el-input
        v-model="form.textarea"
        style="margin-top:18px;"
        type="textarea"
        resize="none"
        :rows="1"
        maxlength="50"
        show-word-limit
        placeholder="请输入备注信息"
      />
    </div>
    <el-table :data="orderData.products.stockList" style="width: 100%">
      <el-table-column prop="date" width="86">
        <template slot-scope="scope">
          <img
            v-if="scope.row.fCover || scope.row.FCover"
            width="66px"
            height="66px"
            :src="scope.row.fCover || scope.row.FCover"
          >
          <img v-else width="66px" height="66px" :src="moren">
        </template>
      </el-table-column>
      <el-table-column prop="name" label="商品" width="450" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="contentText">
            <div class="text">{{ scope.row.fStockName }}</div>
            <div>
              <span class="itemclass">订货编码：</span>
              <span>{{ scope.row.FShortCode }}</span>
            </div>
            <div>
              <span class="itemclass">需方编码： </span>
              <span>{{ scope.row.FDemandStcokCode }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="单价/数量" show-overflow-tooltip>
        <template slot-scope="scope">
          <template v-if="FPriceShow">
            {{ '￥' + stockPrice(scope.row.fStockPrice||0,scope.row.FTPriceDecimal) }}
          </template>
          <span v-else id="noShowPrice" style="margin-right: 5px;">
            <span style="margin:0;">￥</span>价格不可见
          </span>
          <span style="margin:0 3px;">X</span>
          {{ scope.row.fQuanty }}
          {{ scope.row.fMeasurement ? "/" + scope.row.fMeasurement : "" }}
        </template>
      </el-table-column>
      <el-table-column prop="address" label="金额" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="FPriceShow" style="font-weight:bold;">
            ￥<span
              style="font-size:18px;"
            >
              <!-- {{ (scope.row.radioPrice == "1" ? scope.row.taxSumMoney : scope.row.unTaxSumMoney).toFixed(2) }} -->
              {{ stockPrice((scope.row.radioPrice == "1" ? scope.row.fQuanty * (scope.row.fStockPrice || 0) : scope.row.unTaxSumMoney),2) }}
            </span>
          </span>
          <span v-else id="noShowPrice">
            <span style="margin:0;">￥</span>价格不可见
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="明细备注">
        <template slot-scope="scope">
          <el-input v-model="scope.row.fDetailRemark" placeholder="请输入备注信息" />
        </template>
      </el-table-column>
    </el-table>

    <div class="shopFooter">
      <div class="rightBox">
        <span class="orderMoney">
          应付金额：
          <strong> {{ payableMoney }}</strong>元
          <!-- <span v-else id="noShowPrice">
            <span style="margin:0;">￥</span>价格不可见
          </span> -->
        </span>
        <div
          :class="isDisable ? 'orderButton closeBtn disableBtn' : 'orderButton closeBtn' "
          @click="noolder()"
        >取消订单</div>
        <div
          :class="isDisable ? 'orderButton disableBtn' : 'orderButton'"
          @click="placeOrderdata(form.address, orderData)"
        >
          {{ submitText }}
        </div>
      </div>
    </div>
    <!-- 收货地址新增/修改 -->
    <!-- <div v-if="addAddressDialog" class="add-address-dialog"> -->
    <el-dialog
      ref="adddia"
      :append-to-body="true"
      :title="title"
      :visible.sync="addAddressDialog"
      width="620px"
      center
      class="add-address-dialog"
      @close="handleClose"
    >
      <div @click="addressclose">
        <el-form ref="addAddressForm" :model="addAddressForm" label-width="130px" size="mini">
          <el-form-item label="收货人">
            <el-input
              v-model="addAddressForm.name"
              placeholder="请输入收货人姓名"
              style="width: 170px"
              autocomplete="off"
            />
          </el-form-item>
          <el-form-item label="联系方式">
            <el-input
              v-model="addAddressForm.mobile"
              maxlength="11"
              placeholder="请输入手机号"
              style="width: 170px"
              autocomplete="off"
            />
          </el-form-item>
          <el-form-item label="选择地区">
            <div style="position: relative">
              <div class="addressSelectCity" @click.stop="changeaddress">
                <el-input v-model="addAddressForm.address" placeholder="请输入内容" />
                <svg-icon
                  :class="{ 'arrowTransform': !flag, 'arrowTransformReturn': flag }"
                  icon-class="xia"
                />
              </div>
              <!-- <div class="addressSelectCity" @click.stop="changeaddress">
                <el-input
                  v-model="addAddressForm.address"
                  placeholder="请输入内容"
                />
                <svg-icon
                  :class="{
                    arrowTransform: !flag,
                    arrowTransformReturn: flag,
                  }"
                  icon-class="xia"
                />
              </div> -->
              <div v-show="flag" class="address-down" @click.stop="abc">
                <el-tabs ref="elTabs" type="border-card">
                  <el-tab-pane :label="tagAdderr(addressAll)">
                    <div style="width:">
                      <template>
                        <el-tag
                          v-for="(item, index) in addressAll"
                          v-bind="tagColor(item)"
                          @click.stop="addxz1(item.fname, item.fid, index)"
                        > {{ item.fname }}
                        </el-tag>

                      </template>

                    </div>
                  </el-tab-pane>

                  <template v-if="address2.length">
                    <el-tab-pane :label="tagAdderr(address2)">
                      <div style="width:">
                        <template>
                          <el-tag
                            v-for="(item, index) in address2"
                            v-bind="tagColor(item)"
                            @click.stop="addxz2(item.fname, item.fid, index)"
                          >
                            {{ item.fname }}</el-tag>

                        </template>

                      </div>
                    </el-tab-pane>
                  </template>

                  <template v-if="address3.length">
                    <el-tab-pane :label="tagAdderr(address3)">
                      <div style="width:">
                        <template>
                          <el-tag
                            v-for="(item, index) in address3"
                            v-bind="tagColor(item)"
                            @click.stop="addxz3(item.fname, item.fid, index)"
                          >
                            {{ item.fname }}</el-tag>

                        </template>

                      </div>
                    </el-tab-pane>
                  </template>

                  <template v-if="address4.length">
                    <el-tab-pane :label="tagAdderr(address4)">
                      <div style="width:">
                        <template>
                          <el-tag
                            v-for="(item, index) in address4"
                            v-bind="tagColor(item)"
                            @click.stop="addxz4(item.fname, item.fid, index)"
                          >
                            {{ item.fname }}</el-tag>

                        </template>

                      </div>
                    </el-tab-pane>
                  </template>

                </el-tabs>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="详细地址">
            <el-input
              v-model="addAddressForm.addressInfo"
              placeholder="请输入详细地址"
              type="textarea"
              resize="none"
              autocomplete="off"
            />
          </el-form-item>
          <el-form-item label="设为默认收货地址">
            <el-switch v-model="addAddressForm.delivery" :active-value="1" :inactive-value="0" />
          </el-form-item>
        </el-form>
        <div class="add-address-close">
          <el-button @click="handleClose">取消</el-button>
          <el-button @click="determine">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="确认订单" :visible.sync="dialogVisible" width="30%" center :before-close="handleClosex">
      <el-radio v-for="(item, index) in paymode" :key="index" v-model="form.payment" label="1">
        <div style="display: inline-block">
          <span>当前可用额度： {{ item.availableAmount }}</span>
          <span style="margin-left: 50px">账期: {{ item.accountPeriod }} </span>
        </div>
      </el-radio>
      <p class="tips">您的付款日:每月
        <span>{{ timeData.fPaymentDay }}</span>
        日 法定节假日可顺延</p>
      <!-- <p class="tips">
          温馨提示：可用额度=授信额度+商城往来额度+充值奖励金
          下单优先使用充值奖励金！
        </p> -->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit(form.address, orderData.products)">确认交易</el-button>
      </span>
    </el-dialog>
    <approvalTips
      text-margin="35"
      text-width="235"
      :tips-data="tipsData"
      :tips-visible="approvalTipsVisible"
      @tipsSwitch="approvalTipsSwitch"
    />
    <!-- </div> -->
  </div>
</template>
<script>
import approvalTips from '@/components/small-tips/index.vue'
import {
  getaddres,
  settlementShoppingCart
} from '@/api/placeOrder'
import {
  getByNow,
  gosShaopOrder,
  confirmTransaction
} from '@/api/shopDetails'
import qs from 'qs'
import {
  addUseraddress,
  queryArea,
  page,
  queryUseraddress,
  updateDefault,
  updateUseraddress,
  deleteUseraddress
} from '@/api/address'
export default {
  components: {
    approvalTips
  },
  data() {
    return {
      ApprovalList: [],
      BuyDepartList: [],
      processArr: [{
        text: '一级审批',
        svgClass: '',
        style: 'background:#F66666;'
      },
      {
        text: '二级审批',
        svgClass: 'first-line',
        style: 'background:#F6A066;'
      },
      {
        text: '三级审批',
        svgClass: 'second-line',
        style: 'background:#42DFBA;'
      },
      {
        text: '四级审批',
        svgClass: 'thired-line',
        style: 'background:#6692F6;'
      },
      {
        text: '五级审批',
        svgClass: 'fourth-line',
        style: 'background:#A76DFF;'
      }
      ],
      isDisable: false,
      approvalTipsVisible: false,
      tipsData: {
        title: '审批提示',
        svgClass: 'approvalTips',
        text: '提交的订单需要审批请关注审批查询进度'
      },
      submitText: '',
      moren: require('@/assets/images/no-pic.jpg'),
      paymode: [{ availableAmount: 0 }],
      newpaymode: [{
        name: '支付宝',
        value: '1'
      },
      {
        name: '微信',
        value: '2'
      },
      {
        name: '对公转账',
        value: '3'
      }
      ],
      dataMoney: 0,
      totalMoney: '',
      noTotalMoney: '',
      addname1: {
        fid: null,
        fname: ''
      },
      addname2: {
        fid: null,
        fname: ''
      },
      addname3: {
        fid: null,
        fname: ''
      },
      addname4: {
        fid: null,
        fname: ''
      },
      orderData: {
        message: [],
        settlementTotalMoney: '',
        products: []
      },
      departInfo: {
        FAccountNo: '',
        FBank: '',
        FDepartID: '',
        FDepartName: '',
        FERPUnitID: '',
        FInvoiceUnitName: '',
        FTaxNo: ''
      },
      approvalInfo: {
        ApprovalDetailList: [],
        FApprovalName: '',
        FApprovalPolicyID: ''
      },
      form: {
        address: {
          name: '',
          phone: '',
          addrs: ''
        },
        textarea: '', //
        payment: '1' // 支付方式
      },
      isaddressSelect: false,
      mallstoreStockId: 2,
      sum: 1,
      source: '',
      addAddressForm: {
        name: '',
        mobile: '',
        address: '',
        addressInfo: '',
        delivery: 0
      }, // 新增收货地址
      address1: [],
      address2: [],
      address3: [],
      address4: [],
      add1: false,
      add2: false,
      add3: false,
      add4: false,
      flag: false,
      addAddressDialog: false, // 新增收货地址
      title: '', // 新增或修改dialogtitle
      dialogVisible: false,
      infoList: [],
      radioPrice: '1',
      stodata: [],
      timeData: {},
      addressAll: [],
      FPriceShow: 0,
      payableMoney: 0,
      fdong:false,//防抖
      IsDirectSales:false
    }
  },
  computed: {
    tagColor() {
      return (item) => {
        return item.class ? {
          style: 'color:#fff;', color: '#EC212D'
        } : {
          color: '#fff',
          style: 'color:#000;border:none;'
        }
      }
    },
    tagAdderr() {
      return (arr = []) => {
        const next = arr.find(item => item.class)
        return next ? next.fname : '请选择'
      }
    }
  },
  created() {
    queryArea({
      fid: 0
    }).then((res1) => {
      queryArea({
        fid: res1[0].fid
      }).then((res) => {
        this.address1 = res
        this.address1.map((item) => {
          item.class = false
        })
        this.addressAll = JSON.parse(JSON.stringify(this.address1))
        this.add1 = true
      })
    })
  },
  mounted() {
    const userInfor = localStorage.getItem('userInfo')
    userInfor && (this.FPriceShow = JSON.parse(userInfor).FPriceShow)
    if (this.$route.query) {
      const routerData = this.$route.query
      let arr = {}
      if (routerData.data) {
        const datastr = JSON.parse(routerData.data)
        this.source = routerData.source
        const storeList = []
        datastr.map((item) => {
          storeList.push({
            fStoreStockId: item.storeId,
            fMallStoreID: item.id,
            fQuanty: item.num
          })
        })
        arr = {
          jsonobj: JSON.stringify({
            fSource: routerData.source,
            fStoreStockIdList: storeList
          })
        }
        this.placeOrder(arr)
      } else {
        this.source = routerData.source
        arr = {
          jsonobj: JSON.stringify({
            fSource: routerData.source,
            fStoreStockIdList: [{
              fStoreStockId: routerData.id,
              fQuanty: routerData.num
            }]
          })
        }
        this.placeOrder(arr)
      }
    }
    this.getAddresData()
  },
  methods: {
    stockPrice(val,FTPriceDecimal) {
      let price = val||0;
      console.log(val)
      if(FTPriceDecimal!=undefined||FTPriceDecimal!=null)price = val.toFixed(FTPriceDecimal);
      else price=val.toFixed(2);
      price=String(parseFloat(price||0));
      return price
    },
    approvalChange(t, i) {
      this.approvalInfo = t
    },
    departChange(t, i) {
      this.departInfo = t
    },
    moneyFilter(val) {
      if (!isNaN(Number(val))) {
        const num = Number(val).toFixed(3)
        const index = num.indexOf('.')
        const str = num.slice(index, index + 3)
        const dnum = num.slice(0, index)
        let length = dnum.length
        let lengthnum = 0
        let newstr = ''
        do {
          let dou = ''
          if (lengthnum % 3 == 0) {
            dou = ','
          }
          length--
          lengthnum++
          newstr += dou + dnum[length]
        } while (length)
        if (newstr[0] === ',') {
          newstr = newstr.slice(1)
        }
        let mony = newstr
          .split('')
          .reverse()
          .join('') + str
        if (mony.indexOf('-,') > -1) {
          mony = mony.replace(',', '')
        }
        return (
          mony.split('.')
        )
      }
    },
    approvalTipsSwitch() {
      this.isDisable = true
      this.approvalTipsVisible = false
      this.$router.push({
        path: '/approvalQuery/approvalQuery'
      })
    },
    FixedTo(num) {
      const str = !isNaN(Number(num)) ? Number(num).toFixed(3) : '0.00'
      const index = str.indexOf('.')
      return str.slice(0, index + 3)
    },
    handleClosex() {
      this.dialogVisible = false
      this.$router.push({
        path: '/order/orderManagement'
      })
    },
    // 省
    addxz1(fadd, fid, index) {
      this.addname1.fname = fadd
      this.addname2.fname = ''
      this.addname3.fname = ''
      this.addname4.fname = ''
      this.addname1.fid = fid
      this.addname2.fid = null
      this.addname3.fid = null
      this.addname4.fid = null
      this.address1.map(item => {
        item.class = false
      })
      this.addressAll.map(item => {
        item.class = false
      })
      this.addressAll[index].class = true
      this.address3 = []
      this.address4 = []
      queryArea({
        fid: fid
      }).then(res => {
        if (res.length === 0) {
          this.addAddressForm.address = this.addname1.fname
          this.add1 = true
          this.add2 = false
          this.add3 = false
          this.add4 = false
          this.flag = false
        } else {
          this.address2 = res
          this.address2.map(item => {
            item.class = false
          })
          this.add1 = true
          this.add2 = true
          this.add3 = false
          this.add4 = false
          this.$refs.elTabs.currentName = '1'
        }
      })
    },
    // 市
    addxz2(fadd, fid, index) {
      this.addname2.fname = fadd
      this.addname3.fname = ''
      this.addname4.fname = ''
      this.addname2.fid = fid
      this.addname3.fid = null
      this.addname4.fid = null
      // this.addAddressForm.address = this.addname1.fname + '/' + this.addname2.fname
      this.address2.map(item => {
        item.class = false
      })
      this.address2[index].class = true
      this.address4 = []
      queryArea({
        fid: fid
      }).then(res => {
        if (res.length === 0) {
          this.addAddressForm.address = this.addname1.fname + '/' + this.addname2.fname
          this.add1 = true
          this.add2 = true
          this.add3 = false
          this.add4 = false
          this.flag = false
        } else {
          this.address3 = res
          this.address3.map(item => {
            item.class = false
            this.add1 = true
            this.add2 = true
            this.add3 = true
            this.add4 = false
          })
          this.$refs.elTabs.currentName = '2'
        }
      })
    },
    // 县
    addxz3(fadd, fid, index) {
      this.addname3.fname = fadd
      this.addname4.fname = ''
      this.addname3.fid = fid
      this.addname4.fid = null
      this.address3.map(item => {
        item.class = false
      })
      this.address3[index].class = true
      queryArea({
        fid: fid
      }).then(res => {
        if (res.length === 0) {
          this.addAddressForm.address = this.addname1.fname + '/' + this.addname2.fname + '/' +
                            this.addname3.fname
          this.add1 = true
          this.add2 = true
          this.add3 = true
          this.add4 = false
          this.flag = false
        } else {
          this.address4 = res
          this.address4.map(item => {
            item.class = false
          })
          this.add1 = true
          this.add2 = true
          this.add3 = true
          this.add4 = true
          this.$refs.elTabs.currentName = '3'
        }
      })
    },
    // 街道
    addxz4(fadd, fid, index) {
      this.addname4.fname = fadd
      this.addname4.fid = fid
      this.addAddressForm.address = this.addname1.fname + '/' + this.addname2.fname + '/' + this.addname3
        .fname + '/' + this.addname4.fname
      this.address4.map(item => {
        item.class = false
      })
      this.address4[index].class = true
      this.flag = false
      this.$forceUpdate()
    },
    changeaddress() {
      this.flag = !this.flag
      this.$refs.elTabs.currentName = '0'
    },
    addressclose() {
      this.flag = false
    },
    determine() {
      let id = null
      let name = ''
      if (this.addname4.fname === '') {
        if (this.addname3.fname === '') {
          if (this.addname2.fname === '') {
            if (this.addname1.fname !== '') {
              id = this.addname1.fid
              name = this.addname1.fname
            }
          } else {
            id = this.addname2.fid
            name = this.addname2.fname
          }
        } else {
          id = this.addname3.fid
          name = this.addname3.fname
        }
      } else {
        id = this.addname4.fid
        name = this.addname4.fname
      }
      if (this.title === '新增收货地址') {
        addUseraddress({
          faddress: this.addAddressForm.addressInfo,
          fdefault: this.addAddressForm.delivery,
          fareaId: id,
          fareaName: name,
          fname: this.addAddressForm.name,
          fphoneNo: this.addAddressForm.mobile
        }).then((res) => {
          if (res.result) {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
            this.getAddresData()
            this.addAddressDialog = false
          }
        })
      } else {
        updateUseraddress({
          fid: this.fid,
          faddress: this.addAddressForm.addressInfo,
          fdefault: this.addAddressForm.delivery,
          fareaId: id,
          fareaName: name,
          fname: this.addAddressForm.name,
          fphoneNo: this.addAddressForm.mobile
        }).then((res) => {
          if (res.result) {
            this.$message({
              type: 'success',
              message: '修改成功!'
            })
            this.onsearch()
            this.addAddressDialog = false
          }
        })
      }
    },
    handleClose() {
      this.addressAll.findIndex(item => {
        if (item.class) {
          item.class = false
        }
      })
      //   if (this.address2.length) {
      //     this.address2.findIndex(item => {
      //       if (item.class) {
      //         item.class = false
      //       }
      //     })
      //   }
      //   if (this.address3.length) {
      //     this.address3.findIndex(item => {
      //       if (item.class) {
      //         item.class = false
      //       }
      //     })
      //   }
      this.address2 = []
      this.address3 = []
      this.address4 = []
      this.add2 = false
      this.add3 = false
      this.add4 = false
      this.addname1 = {
        fid: null,
        fname: ''
      }
      this.addname2 = {
        fid: null,
        fname: ''
      }
      this.addname3 = {
        fid: null,
        fname: ''
      }
      this.addname4 = {
        fid: null,
        fname: ''
      }
      this.flag = false
      this.addAddressForm = {
        name: '',
        mobile: '',
        address: '',
        addressInfo: '',
        delivery: 0
      }
      this.addAddressDialog = false
    },
    noolder() {
      if (this.isDisable) {
        return
      }
      this.$router.push({
        path: '/shop/shoppingCart'
      })
      this.$message({
        message: '取消订单成功',
        type: 'success'
      })
    },
    submit() {
      const arr = {
        jsonobj: JSON.stringify({
          fnoList: this.infoList
        })
      }
      confirmTransaction(qs.stringify(arr)).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: 'success'
          })
          this.$router.push({
            path: '/order/orderManagement'
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 提交订单
    placeOrderdata(val, valdata) {
      if (this.isDisable) return
      if (this.ApprovalList.length && !this.approvalInfo.FApprovalPolicyID) return this.$message.warning('请选择审批流程')
      if(this.IsDirectSales&& !this.departInfo.FDepartID){
        return this.$message.warning('请选择下单部门')
      }else if (this.BuyDepartList.length && !this.departInfo.FDepartID) return this.$message.warning('请选择下单部门')
      
      if(this.fdong)return;
      this.fdong=true;
      setTimeout(()=>{ this.fdong=false;},800)
      if (this.orderData.message.length > 0) {
        const arr = {
          jsonobj: {
            fSource: this.source,
            fReceiver: val.fname,
            fReceiverPhoneNo: val.fPhoneNo,
            fReceiverAreaID: val.fAreaID,
            fReceiverAddress: val.fLevelName + val.fAddress,
            fRemark: this.form.textarea,
            stockList: [],
            fDemandDepartID: this.departInfo.FDepartID,
            fCustomerID: this.departInfo.FERPUnitID,
            FApprovalPolicyID: this.approvalInfo.FApprovalPolicyID
          }
        }
        valdata.products.stockList.map((item) => {
          arr.jsonobj.stockList.push({
            fStockName: item.fStockName,
            fMallStoreId: item.fMallStoreID,
            fStoreStockID: item.mallstoreStockId,
            fQuanty: item.fQuanty,
            fTotalPrice: item.fStockPrice,
            fDetailRemark: item.fDetailRemark
          })
        })
        const datastr = JSON.stringify(arr.jsonobj)
        const dataobj = {
          jsonobj: datastr
        }
        const dataParams = dataobj

        gosShaopOrder(qs.stringify(dataParams)).then((res) => {
          if (res.code == 200) {
            if (res.result == true) {
              if (res.data.fIsApproval) {
                this.approvalTipsVisible = true
              } else {
                this.infoList = res.data.orderNoList
                this.dialogVisible = true
              }
            } else {
              this.$message.error(res.msg)
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.error('请完善信息')
      }
    },
    // 获取数据
    placeOrder(data) {
      getByNow(qs.stringify(data)).then((res) => {
        this.ApprovalList = res.data.ApprovalList || []
        if (res.data.ApprovalList && res.data.ApprovalList.length == 1) {
          this.approvalInfo = res.data
            .ApprovalList[0]
        }
        if (res.data.BuyDepartList && res.data.BuyDepartList.length == 1) {
          this.departInfo = res.data.BuyDepartList[0]
        }
        this.IsDirectSales=res.data.IsDirectSales;
        this.BuyDepartList = res.data.BuyDepartList || []
        this.submitText = res.data.fIsApproval ? '提交申请' : '提交订单'
        this.stodata = res.data.stockList
        this.stodata.map((item) => {
          item.fOutDayLimit = res.data.fOutDayLimit
        })
        this.orderData.products = res.data
        this.orderData.settlementTotalMoney = res.data.settlementTotalMoney
        const list = JSON.parse(data.jsonobj).fStoreStockIdList
        let num = 0
        this.orderData.products.stockList.map((item, i) => {
          this.$set(item, 'sum', '')
          this.$set(item, 'dataMoney', 0)
          this.$set(item, 'radioPrice', '1')
          this.$set(item, 'fDetailRemark', '')
          if(this.$route.query.data){
            item.fQuanty = list[list.findIndex(t => item.mallstoreStockId == t.fStoreStockId)].fQuanty
            // item.FTPriceDecimal=(params.find(t => item.mallstoreStockId == t.storeId)||{}).FTPriceDecimal
          }else{
            item.fQuanty = list[list.findIndex(t => item.mallstoreStockId == t.fStoreStockId)].fQuanty
            // item.FTPriceDecimal=(params.find(t => item.mallstoreStockId == t.storeId)||{}).FTPriceDecimal
          }
          
          num += Number((item.fQuanty * (item.fStockPrice || 0)).toFixed(2))
        })

        this.payableMoney = num.toFixed(2)
        if (this.radioPrice == 1) {
          this.totalMoney = res.data.taxTotalMoney
          this.dataMoney = Number(res.data.stockList[0].taxSumMoney)
        } else {
          this.noTotalMoney = res.data.unTaxTotalMoney
        }
      })
    },
    // 查询收货地址
    getAddresData() {
      getaddres().then((res) => {
        this.timeData = res.data
        if (res.data.addressList.length > 0) {
          res.data.addressList.map((t, i) => {
            t['index'] = i
          })
          this.orderData.message = res.data.addressList
          this.form.address = res.data.addressList[0]
        }
        this.paymode = res.data.paymentTypeList
      })
    },
    priceChoose(item, val, num) {
      this.totalMoney = ''
      this.noTotalMoney = ''
      this.dataMoney = ''
      const beforeSum = item.sum
      if (val.radioPrice == 1) {
        this.totalMoney = item.products.taxTotalMoney
        val.dataMoney = val.taxSumMoney
        // val.fQuanty = val.
        // item.products.stockList.map((it) => {
        //   it.dataMoney = 0;
        //   it.dataMoney += Number(it.taxSumMoney);
        // });
      } else {
        this.noTotalMoney = item.products.unTaxTotalMoney
        val.dataMoney = val.unTaxSumMoney
        // item.products.stockList.map((it) => {
        //   it.dataMoney = 0;
        //   it.dataMoney += Number(it.unTaxSumMoney);
        // });
      }
    },
    command(item, index) {
      this.form.address = {
        fname: item.fname,
        fPhoneNo: item.fPhoneNo,
        fLevelName: item.fLevelName,
        fAddress: item.fAddress,
        index: item.index
      }
    },
    // 获取收货地址下拉框的显示与隐藏
    visibleChange(e, form) {
      this.isaddressSelect = e
    },
    // 点击了新增按钮
    addButton(title) {
      this.title = title
      this.addAddressDialog = true
      // let data = this.$refs.adddia
    }
  }
}
</script>

<style lang='scss'>
    .submitBox {
        .el-table {
            .el-table__body-wrapper {
                .el-table__cell .cell {
                    height: 74px;
                }
            }
        }

        .approval-box {
            margin-top: 18px;
        }

        .process-list {
            display: flex;

            .svg-icon {
                position: relative;
                top: 16px;
                margin: 0 3px;
                font-size: 30px;
            }
        }

        .process-box {
            width: 153px;
            height: 63px;
            border-radius: 6px;
            background-color: #F66666;

            .process-title {
                height: 23px;
                line-height: 23px;
                font-size: 12px;
                color: #FFFFFF;
                padding: 0 9px;
            }

            .process-content {
                width: 144px;
                height: 36px;
                margin: 0 5px;
                border-radius: 6px;
                background-color: #fff;
                font-size: 14px;
                color: #797E8D;
                display: flex;
                align-items: center;
                padding: 0 3px;

                .process-text {
                    white-space: normal;
                    line-height: 18px;
                    display: -webkit-box;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: break-all;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2; //此处为行数，可以改为任意数字
                }
            }
        }
    }

    .address-down {
        width: 394px;

        .el-tabs__item {
            height: 32px;
            line-height: 32px;
        }

        .el-tabs__header {
            height: auto;
        }

        .el-tabs__header .el-tabs__nav {
            width: auto;
        }

        .el-tabs__header .el-tabs__nav-scroll,
        .el-tabs__header .el-tabs__nav,
        .el-tabs__header .el-tabs__nav-wrap {
            line-height: normal;
            height: auto;
        }

        .el-tag {
            padding: 0 7px;
            line-height: 26px;
            height: 26px;
            margin: 0 5px;
            cursor: pointer;
            min-width: 52px;
        }

        .el-tag:hover {
            background-color: #EC212D !important;
            color: #fff !important;
        }

        .el-tabs__item {
            color: #000;
        }

        .is-top .is-active {
            background-color: #EC212D !important;
            color: #fff !important;
        }

        .el-tabs--border-card>.el-tabs__content {
            padding: 8px;
        }
    }
</style>
<style lang="scss" scoped>
    .shopFooter {
        width: 100%;
        height: 46px;
        background: #ffffff;
        margin-top: 20px;

        .rightBox {
            float: right;

            .orderMoney {
                overflow: hidden;
                height: 44px;
                display: inline-block;
                font-size: 14px;
                color: #333;
                line-height: 44px;

                strong {
                    font-size: 24px;
                    color: #ec212d;
                }
            }
        }

        .orderButton {
            display: inline-block;
            overflow: hidden;
            width: 220px;
            height: 46px;
            background: #ec212d;
            font-size: 18px;
            color: #fff;
            text-align: center;
            line-height: 44px;
            cursor: pointer;
        }

        .closeBtn {
            background-color: #fff;
            color: #999999;
            border: 1px solid #E9E9E9;
            margin-left: 40px;
        }

        .disableBtn {
            background-color: #bfbbbb;
            cursor: not-allowed;
        }
    }

    .contentText {
        font-size: 14px;
        color: #777;
        text-align: left;

        .text {
            height: 25px;
            font-size: 16px;
            font-weight: bold;
            color: #333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .itemclass {
            //   font-weight: bold;
        }
    }

    .tips {
        margin-top: 20px;
        // color: #99c1e9;
    }

    .add-address-dialog {
        .add-address-close {
            text-align: center;
        }

        button {
            width: 135px;
            height: 30px;
            line-height: 30px;
            padding: 0;
        }

        .add-address-close button:first-child {
            color: #ec212d;
            background-color: #fff;
            border: 1px solid #ec212d;
        }

        .add-address-close button:last-child {
            color: #fff;
            background-color: #ec212d;
            border: 1px solid #ec212d;
        }
    }

    .el-tooltip__popper .is-dark {
        font-size: 12px;
        opacity: 0.6;
    }

    .el-form-item__label {
        font-weight: 400;
    }

    .submitBox {
        width: 100%;
        margin: 30px 0;

        //   background-color: #fff;
        .showAddress {
            margin-bottom: 10px;
            padding: 30px 20px;
            background-color: #fff;
            border-radius: 6px;

            .el-textarea__inner {
                height: 36px;
                line-height: 24px;
            }

            .departInfo {
                position: relative;
                width: 748px;
                height: 96px;
                background: #F1F1F1;
                margin-top: 18px;
                padding: 0 20px;
                color: #333333;
                font-size: 14px;

                .content {
                    display: flex;
                    flex-wrap: wrap;
                }

                p {
                    width: 354px;
                    line-height: 48px;
                }

                .topArrow {
                    position: absolute;
                    top: -20px;
                    left: 50px;
                    width: 0;
                    height: 0;
                    border: 10px solid transparent;
                    border-bottom-color: #F1F1F1;
                }

                .title {
                    display: inline-block;
                    width: 70px;
                    text-align: justify;
                    text-justify: distribute-all-lines;
                    text-align-last: justify;
                    color: #777777;
                }
            }

            .useQuato {
                display: flex;
                align-items: end;
                height: 40px;
                margin-top: 18px;
                margin-left: 20px;
                font-size: 14px;
                color: #333;

                span {
                    color: #EC212D;
                    font-weight: bold;
                }
            }

            .moreAddress {
                margin-top: 18px;
                font-size: 14px;
                color: #333;
            }

            .info-box {
                display: inline-block;
                cursor: pointer;
                position: relative;
                margin-top: 18px;
                max-width: 946px;
                height: 40px;
                line-height: 40px;
                padding-left: 20px;
                border: 1px solid #EC212D;
                border-radius: 4px;
                font-size: 14px;
                color: #333;

                .addressInfo {
                    display: inline-block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .default {
                    display: inline-block;
                    position: absolute;
                    right: 105px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 43px;
                    height: 18px;
                    line-height: 18px;
                    font-size: 12px;
                    text-align: center;
                    background: #EC212D;
                    color: #fff;
                    border-radius: 2px;
                }

                .addAddress {
                    position: absolute;
                    right: 28px;
                    color: #EC212D;
                }

                .svg-icon {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    font-size: 20px;
                }
            }
        }

        #noShowPrice {
            display: inline-block;
            text-align: center;
            font-size: 14px;
            color: #ec2631;
            font-weight: 400;

            span {
                font-size: 12px;
            }
        }
    }

    .addressSelectCity {
        .arrowTransform {
            position: absolute;
            right: 17px;
            top: 7px;
            transition: 0.2s;
            transform-origin: center;
            transform: rotateZ(180deg);
        }

        .arrowTransformReturn {
            position: absolute;
            right: 17px;
            top: 7px;
            transition: 0.2s;
            transform-origin: center;
            transform: rotateZ(0deg);
        }
    }

    .address {
        width: 700px;
        height: 62px;
        border: 1px solid #d2d2d2;
        font-size: 14px;
        padding: 11px;
        position: relative;
        float: left;

        .name {
            color: #333;
            line-height: 23px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .bottom {
            color: #999;
            line-height: 23px;
        }

        .select {
            position: absolute;
            top: 11px;
            right: 11px;
            font-size: 16px;
        }

        .rotate {
            transform: rotate(0deg);
            transition: all 0.5s;
        }

        .toback {
            transform: rotate(-180deg);
            transition: all 0.5s;
        }
    }

    .address-down {
        position: absolute;
        top: 30px;
        left: 0px;
        z-index: 1000;
        display: flex;
        margin: 5px 0;
        font-size: 14px;
        background: #fff;
        border: 1px solid #e4e7ed;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
        overflow: auto;

        .add {
            overflow-y: auto;
            height: 170px;
            width: 170px;

            .box {
                position: relative;
                display: flex;
                align-items: center;
                padding-left: 10px;
                padding-right: 30px;
                height: 34px;
                line-height: 34px;
                outline: none;

                .el-icon-arrow-right {
                    position: absolute;
                    right: 10px;
                }
            }

            .box-blue {
                color: skyblue;
                position: relative;
                display: flex;
                align-items: center;
                padding-left: 10px;
                padding-right: 30px;
                height: 34px;
                line-height: 34px;
                outline: none;

                .el-icon-arrow-right {
                    position: absolute;
                    right: 10px;
                }
            }
        }
    }

    .departSelect {
        max-height: 450px;
        overflow-y: auto;
        z-index: 999;
        position: absolute;
        top: 64px;
        border: 1px solid #d2d2d2;
        width: 352px;
    }

    .addressSelect {
        max-height: 450px;
        overflow-y: auto;
        width: 944px;
        z-index: 999;
        position: absolute;
        top: 64px;
        // left: 1400px !important;
        border: 1px solid #d2d2d2;
    }

    .departList {
        border-bottom: 1px solid #d2d2d2;
    }

    .addressList {
        border-bottom: 1px solid #d2d2d2;
        position: relative;
        height: 62px;
        padding: 11px;

        .name {
            line-height: 23px;
        }

        .bottom {
            color: #999;
            line-height: 23px;
        }

        &:first-child {
            &::after {
                content: "默认";
                width: 43px;
                height: 18px;
                line-height: 18px;
                position: absolute;
                top: 23px;
                right: 15px;
                background: #EC212D;
                //   opacity: 0.6;
                border-radius: 4px;
                font-size: 12px;
                color: #fff;
                text-align: center;
                line-height: 16px;
                padding: 1px 0;
            }
        }
    }

    .addrsListButton {
        .addButton {
            width: 92px;
            height: 24px;
            background: #ffffff;
            border: 1px solid #ec212d;
            border-radius: 4px;
            font-size: 12px;
            color: #ec212d;
            text-align: center;
            line-height: 22px;
            margin: 20px 0 20px 20px;
            position: absolute;
            right: -110px;

            &:hover {
                cursor: pointer;
            }
        }
    }

    .addrsTransition {
        transition: height 5s;
    }

    .payment {
        width: 700px;
        height: 116px;
        padding: 20px;
        border: 1px solid #d2d2d2;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }

    .shopTab {
        .shopTop {
            width: 100%;
            height: 32px;
            background: #f5f5f5;
            border-radius: 5px;
            display: flex;
            justify-content: space-around;
            align-items: center;
            font-size: 14px;
            color: #666;
        }

        .shopdataList {
            border: 1px solid #cdcdcd;
            margin-top: 12px;
            font-size: 14px;
            color: #333;

            .shopContent {
                width: 100%;
                height: 98px;
                //   padding: 0 10px;
                background: #ffffff;
                border-radius: 2px;
                border-bottom: 1px solid #cdcdcd;
                display: flex;
                //   justify-content: space-between;
                justify-content: space-around;
                align-items: center;

                &:last-child {
                    border-bottom: unset;
                }

                .content_con {
                    width: 300px;
                    display: flex;
                }

                .content_price {
                    display: flex;
                    justify-content: center;
                    font-size: 12px;
                    color: #999;

                    .price {
                        //   padding-left: 74px;
                        //   padding-top: 8px;
                    }
                }

                .content_pay {
                    color: #ff812c;
                    font-weight: bold;
                }
            }
        }

        .shopTotal {
            width: 100%;
            height: 55px;
            text-align: right;
            line-height: 55px;
            font-size: 16px;
            color: #999999;
        }

    }

    .content_con {
        width: 300px;
        text-align: center;
    }

    .content_price {
        width: 200px;
        text-align: center;
    }

    .content_num {
        width: 100px;
        text-align: center;
    }

    .content_pay {
        width: 100px;
        text-align: center;
    }

    .content_remarks {
        width: 150px;
        text-align: center;
    }

    .el-dropdown-menu__item:not(.is-disabled):hover {
        background-color: #f4f4f4 !important;

        .name {
            color: #333;
        }

        .bottom {
            color: #999;
        }
    }

    .textarea {
        ::v-deep .el-textarea__inner {
            border-radius: unset;
        }
    }
</style>
